import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";

import imgI from "../assets/images/icons/arrowI.svg";
import imgD from "../assets/images/icons/arrowD.svg";

const apiUrl = process.env.REACT_APP_STRAPI_URL;

export default function Carousel({ images = [] }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const getImageUrl = (item) => {
    const imgData = Array.isArray(item.img) ? item.img[0] : item.img;
    if (imgData?.formats?.large?.url) return apiUrl + imgData.formats.large.url;
    if (imgData?.url) return apiUrl + imgData.url;
    return "";
  };

  const getThumbnailUrl = (item) => {
    const imgData = Array.isArray(item.img) ? item.img[0] : item.img;
    if (imgData?.formats?.small?.url) return apiUrl + imgData.formats.small.url;
    if (imgData?.formats?.thumbnail?.url)
      return apiUrl + imgData.formats.thumbnail.url;
    return getImageUrl(item);
  };

  if (!images || images.length === 0) {
    return (
      <div className="w-full h-96 bg-sidom-light dark:bg-sidom-blue rounded-2xl flex items-center justify-center">
        <p className="text-sidom-dark dark:text-sidom-light">
          No hay imágenes disponibles
        </p>
      </div>
    );
  }

  return (
    <div className="mx-auto px-2 sm:px-4">
      {/* Carrusel Principal */}
      <div className="relative group">
        <Swiper
          modules={[Navigation, Thumbs, Pagination]}
          thumbs={{
            swiper:
              thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
          }}
          loop={true}
          spaceBetween={10}
          pagination={false}
          navigation={{
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
          }}
          className="rounded-2xl"
        >
          {images.map((item, idx) => (
            <SwiperSlide
              key={idx}
              className="bg-sidom-light dark:bg-sidom-blue"
            >
              <div className="w-[80vw] h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px] xl:h-[700px] mx-auto rounded-2xl overflow-hidden relative">
                <img
                  src={getImageUrl(item)}
                  alt={
                    item.img?.[0]?.alternativeText ||
                    item.epigrafe ||
                    `Imagen ${idx + 1}`
                  }
                  className="w-full h-full object-contain"
                  loading={idx === 0 ? "eager" : "lazy"}
                />
                {item.epigrafe && (
                  <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 flex justify-center">
                    <p className="text-sidom-light text-[8px] sm:text-sm bg-black/60 font-medium text-center inline-block px-3 py-1 rounded">
                      {item.epigrafe}
                    </p>
                  </div>
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Botones personalizados */}
        {images.length > 1 && (
          <>
            <button
              type="button"
              className="swiper-button-prev-custom absolute -left-6 sm:-left-8 top-[45%] -translate-y-1/2 z-10 p-2 hover:opacity-75"
              aria-label="Imagen anterior"
            >
              <img src={imgI} alt="anterior" className="w-4 sm:w-5" />
            </button>
            <button
              type="button"
              className="swiper-button-next-custom absolute -right-6 sm:-right-8 top-[45%] -translate-y-1/2 z-10 p-2 hover:opacity-75"
              aria-label="Imagen siguiente"
            >
              <img src={imgD} alt="siguiente" className="w-4 sm:w-5" />
            </button>
          </>
        )}
      </div>

      {/* Carrusel de Miniaturas */}
      {images.length > 2 && (
        <div className="mt-3">
          <Swiper
            onSwiper={setThumbsSwiper}
            modules={[Thumbs]}
            watchSlidesProgress
            freeMode={true}
            className={`thumbnail-swiper ${
              images.length < 5 ? "flex justify-center" : ""
            }`}
            breakpoints={{
              0: { slidesPerView: 3, spaceBetween: 10 },
              640: { slidesPerView: 3, spaceBetween: 40 },
              1024: { slidesPerView: 3, spaceBetween: 40 },
            }}
          >
            {images.map((item, idx) => (
              <SwiperSlide
                key={idx}
                className="flex items-center justify-center cursor-pointer"
              >
                <div className="w-[300px] xl:w-[400px] h-[90px] xl:h-[180px] rounded-xl overflow-hidden bg-black/5">
                  <img
                    src={getThumbnailUrl(item)}
                    alt={`Thumbnail ${idx + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </div>
  );
}
